import { FORMATS, VALUE_SIZES } from './constants';
import mappings from './mappings';
import QuickFacts from './quick-facts-component';
import QuickFactValue, { formatValue } from './quick-fact-value';
export default QuickFacts;
export { FORMATS, VALUE_SIZES, QuickFactValue, formatValue, mappings };